export class ProposalQueryModel {
    startDate: string;
    endDate: string;
    institution: string;
    serviceContract: number;
    proposalStatusId: number[];
    cpfCnpj: string;
    channelType: string;
    channelCode: string;
    subChannelCode: string;
    agentId: string;
    accreditationSource: number;
    accreditationChannel: string;
    baseProductContracted: boolean;
    filterCheckBw: boolean;
    isNotFromFiservOnline: boolean;
}
